const ITEMS = [
  { gold: true, text: "★ Structured Cabling Cat6A" },
  { gold: false, text: "• Fiber Optic Splicing" },
  { gold: true, text: "★ Smart Home Automation" },
  { gold: false, text: "• CCTV & Security Cameras" },
  { gold: true, text: "★ AI Workflows & Web Apps" },
  { gold: false, text: "• DFW Metroplex" },
];

export default function Marquee() {
  return (
    <div className="border-y border-[#d4af37]/20 py-3 bg-[#0d0d10] overflow-hidden" data-testid="services-marquee" aria-hidden="true">
      <div className="mq items-center text-xs font-mono uppercase tracking-widest text-zinc-400">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center gap-8 pr-8">
            {ITEMS.map((item, i) => (
              <span key={i} className={item.gold ? "text-[#d4af37]" : undefined}>{item.text}</span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
